// extracted by mini-css-extract-plugin
module.exports = {"subrnd1":"subrnd1_subrnd1__2W_mN","back-btn":"subrnd1_back-btn__3MmEr","subrnd1-img1":"subrnd1_subrnd1-img1__3Rdjd","subrnd1-img2":"subrnd1_subrnd1-img2__bTqU5"};